// extracted by mini-css-extract-plugin
export default {"wrapper":"fYaZ2eyijbWqF7UOvkVA","inputNumber":"CkkfAtgbY3Gm9hdPmSZw","selectCurrencies":"gxjeRqkKA1gF6Am2mQ9Z","big":"Y2sboJlnLAAZFoMCoKXw"};